export default "__VITE_ASSET__3bPwZf8W__"